import { styled } from '@mui/material/styles';
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

export const MainContent = styled('main')(({ theme }) => ({
    flexGrow: 1,
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.default,
}));

export const MainContainer = styled(Container)(({ theme }) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    flex: 1,
    [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
    },
}));

export const Root = styled(Box)({
    display: 'flex',
    minHeight: '100vh',
    width: '100%',
    position: 'relative',
});

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
    minHeight: '64px',
    zIndex: theme.zIndex.drawer + 1,
    color: 'white',
    background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.07) 0%, rgba(255, 255, 255, 0.03) 100%), #121212',
    backdropFilter: 'blur(10px)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
    boxShadow: 'none',
}));

export const AppBarSpacer = styled('div')(({ theme }) => ({
    ...theme.mixins.toolbar,
    minHeight: '64px',
    flexShrink: 0,
}));